'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Base = require('../Base');

var _Base2 = _interopRequireDefault(_Base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Car = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Car, _Component);

  function Car() {
    (0, _classCallCheck3.default)(this, Car);
    return (0, _possibleConstructorReturn3.default)(this, (Car.__proto__ || (0, _getPrototypeOf2.default)(Car)).apply(this, arguments));
  }

  (0, _createClass3.default)(Car, [{
    key: 'render',
    value: function render() {
      var props = (0, _extends3.default)({}, this.props, {
        width: parseInt(this.props.width, 10),
        height: parseInt(this.props.height, 10)
      });

      return _react2.default.createElement(
        _Base2.default,
        (0, _extends3.default)({ viewBox: '0 27 60 10' }, props),
        _react2.default.createElement(
          'g',
          null,
          _react2.default.createElement('path', { xmlns: 'http://www.w3.org/2000/svg', fill: props.fillWheel1 || props.fill, d: 'M14.272 51.776c0 1.792-1.472 3.264-3.264 3.264h-2.688c-1.792 0-3.264-1.472-3.264-3.264v-7.68c0-1.792 1.472-3.264 3.264-3.264h2.688c1.792 0 3.264 1.472 3.264 3.264v7.68z' }),
          _react2.default.createElement('path', { xmlns: 'http://www.w3.org/2000/svg', fill: props.fillWheel1 || props.fill, d: 'M58.88 51.776c0 1.792-1.472 3.264-3.264 3.264h-2.688c-1.792 0-3.264-1.472-3.264-3.264v-7.68c0-1.792 1.472-3.264 3.264-3.264h2.688c1.792 0 3.264 1.472 3.264 3.264v7.68z' }),
          _react2.default.createElement('path', { xmlns: 'http://www.w3.org/2000/svg', fill: props.fillWheel1 || props.fill, d: 'M60.672 16.384c-1.152 0-4.8 0-4.8 0-0.64 0-1.408 1.472-1.408 1.472-2.304-3.904-4.736-6.912-5.952-7.68-2.624-1.536-6.272-1.536-16.448-1.536-10.24 0-13.888 0.32-16.448 1.856-1.28 0.768-3.648 3.264-5.952 7.104 0 0-0.768-1.28-1.408-1.28 0 0-3.648 0-4.8 0-2.496 0-1.984 2.88-1.984 2.88 0.128 0.704 0.768 0.96 1.472 0.96h2.112c0.064 0 2.112 1.408 1.728 2.752-1.152 2.304-2.048 5.632-2.368 6.848-1.024 3.904 1.28 17.344 3.008 17.344 1.344 0 48 0 49.408 0 1.792 0 4.096-12.864 3.072-16.768-0.32-1.152-1.216-4.608-2.368-6.912-0.32-1.28 1.664-3.2 1.792-3.2h2.112c0.704 0 1.408-0.32 1.472-0.96-0.256 0 0.256-2.88-2.24-2.88zM17.344 13.44c1.728-1.088 5.184-0.704 14.656-0.704s12.928-0.384 14.784 0.768c1.024 0.832 3.264 4.48 5.44 8.384-6.144 0.96-12.992 1.536-20.224 1.536s-14.080-0.576-20.16-1.536c2.112-3.904 4.416-7.616 5.504-8.448zM14.208 37.184c-2.944 0-5.248-2.368-5.248-5.248 0-2.944 2.368-5.312 5.248-5.312 2.944 0 5.312 2.368 5.312 5.312 0 2.88-2.368 5.248-5.312 5.248zM42.24 41.344c-0.32 1.088-1.664 1.92-4.16 1.92h-12.096c-2.432 0-3.904-0.832-4.16-1.92-0.32-1.088 0.384-1.92 1.472-1.92h17.536c1.024 0 1.664 0.896 1.408 1.92zM49.728 37.184c-2.944 0-5.248-2.368-5.248-5.248 0-2.944 2.368-5.312 5.248-5.312 2.944 0 5.248 2.368 5.248 5.312 0.064 2.88-2.304 5.248-5.248 5.248z' })
        )
      );
    }
  }]);
  return Car;
}(_react.Component), _class.propTypes = {
  width: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  height: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  fill: _react.PropTypes.string,
  fillWheel1: _react.PropTypes.string,
  fillWheel2: _react.PropTypes.string,
  className: _react.PropTypes.string
}, _class.defaultProps = {
  width: 16,
  height: 16,
  fill: '#848484'
}, _temp);
exports.default = Car;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseIcons/Car/Car.jsx
// module id = 1591
// module chunks = 0